import * as React from 'react';
import { gql } from '@apollo/client';
import { useCreateInvitedMemberMutation } from '../../../models/graphql';
import {
  InviteTeamMemberModalController,
  InviteTeamMemberModalControllerProps
} from './InviteTeamMemberModal.controller';

export type InviteTeamMemberModalApolloProps = Omit<InviteTeamMemberModalControllerProps, 'createUserInvitation'> & {
  // ...
};

gql`
  mutation CreateInvitedMember($organizationId: ID!, $input: UserInvitationInput!) {
    createUserInvitation(organizationId: $organizationId, input: $input) {
      id
      email
      role
      workspaceIds
      token
    }
  }
`;

export const InviteTeamMemberModalApollo = (props: InviteTeamMemberModalApolloProps): JSX.Element => {
  const [createUserInvitation] = useCreateInvitedMemberMutation();

  const controllerProps: InviteTeamMemberModalControllerProps = {
    ...props,
    createUserInvitation
  };

  return <InviteTeamMemberModalController {...controllerProps} />;
};
